import request from '@/apis/request'
const resource = 'spin-wheels' 

export default {
  get: (params) => {
    return request.get(`${resource}`,{params})
  }, 
}